var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpCenterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1406 15.5156V18.3281",
    stroke: "#5E6A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85938 18.3281V8.48438C2.85938 8.11142 3.00754 7.75373 3.27126 7.49001C3.53498 7.22629 3.89267 7.07812 4.26562 7.07812H7.78125",
    stroke: "#5E6A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4225 18.3281C14.1785 18.7553 13.8259 19.1102 13.4004 19.3571C12.975 19.6041 12.4919 19.7341 12 19.7341C11.5081 19.7341 11.025 19.6041 10.5996 19.3571C10.1741 19.1102 9.82151 18.7553 9.5775 18.3281H1.45312V19.7344C1.45312 20.4802 1.74944 21.1957 2.27689 21.7231C2.80433 22.2505 3.5197 22.5469 4.26562 22.5469H19.7344C20.4802 22.5469 21.1957 22.2505 21.7231 21.7231C22.2505 21.1957 22.5469 20.4802 22.5469 19.7344V18.3281H14.4225Z",
    stroke: "#5E6A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 1.70287C17.2305 1.37323 16.0557 1.36984 14.9507 1.69311C13.8457 2.01638 12.8579 2.65249 12.1064 3.52469C11.3549 4.39689 10.8719 5.46791 10.7156 6.60854C10.5593 7.74917 10.7364 8.91066 11.2256 9.95287L9.29053 13.8801L13.7184 12.6707C14.1089 12.8945 14.5238 13.0728 14.9549 13.2023C16.471 13.6215 18.0912 13.4277 19.4656 12.6629C20.8402 11.8981 21.8589 10.6235 22.3019 9.11419C22.7449 7.60487 22.5767 5.98189 21.8336 4.5955C21.0905 3.20911 19.8321 2.1705 18.3299 1.7038L18.3337 1.70287Z",
    stroke: "#5E6A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91 6.05859C14.91 5.71093 15.0132 5.37108 15.2063 5.08201C15.3994 4.79294 15.674 4.56763 15.9952 4.43459C16.3164 4.30155 16.6698 4.26673 17.0108 4.33456C17.3518 4.40239 17.665 4.5698 17.9108 4.81564C18.1567 5.06147 18.324 5.37469 18.3919 5.71566C18.4597 6.05664 18.4249 6.41008 18.2919 6.73129C18.1588 7.05248 17.9335 7.32701 17.6444 7.52016C17.3554 7.71332 17.0155 7.8164 16.6678 7.8164",
    stroke: "#5E6A7D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6678 10.629C16.4737 10.629 16.3163 10.4715 16.3163 10.2774C16.3163 10.0832 16.4737 9.92578 16.6678 9.92578",
    stroke: "#5E6A7D",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6678 10.629C16.862 10.629 17.0194 10.4715 17.0194 10.2774C17.0194 10.0832 16.862 9.92578 16.6678 9.92578",
    stroke: "#5E6A7D",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterIcon);
export default __webpack_public_path__ + "static/media/help-center-icon.8d4a13173b0b6a665764cb4454e9fd29.svg";
export { ForwardRef as ReactComponent };